module.exports = __webpack_public_path__ + "img/BuffaloStorm_EGM.6eaa972d.png";